import _ from 'underscore';
import BaseView from '../../admin-dashboard-list-base/item/view';
import template from './template.html';

export default BaseView.extend({
	destroyTimeout: null,
	destroyDelay: 1000,

	events: {
		'click .js-handle': 'onClickHandle'
	},

	template: _.template(template),

	/**
	 * Domestic / foreign click handler
	**/
	onClickHandle: function(e) {
		var url = e.currentTarget.value;

		e.preventDefault();

		this.flagInstrument(url);
	},

	flagInstrument: function(url) {
		this.model.destroy({
			url: url,
			wait: true,
			method: 'POST'
		});
	}
});

